import * as _ from 'lodash'
// Libraries
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
// Services
import { ApiService, SettingService } from '../../common/modules/core/services';
// socket
import * as io from 'socket.io-client';

@Injectable()
export class LocationServices {
    private socketUrl: string = '/';
    private socket: any;

    constructor(
        private apiService: ApiService,
        private settingService: SettingService
    ) {
    }

    getMessages(eventListen: string) {
        let observable = new Observable((observer: any) => {
            this.socket = io(this.socketUrl);
            this.socket.on(eventListen, (data: any) => {
                observer.next(data);
            });
            return () => {
                this.socket.disconnect();
            };
        })
        return observable;
    }  

}


// WEBPACK FOOTER //
// ./src/bus/services/LocationServices.ts